import {uuid} from 'uuidv4';
import {MIX_VIEW} from 'constants/view-modes.js';
import Dispatchable from "utils/Dispatchable.js";
import {
    setShowPadSequencer,
    setWindowPosition,
    setSelectedZObject,
    setPads,
    setPadSlots
} from 'actions/index.js';
import Pad from './Pad.js';

export default superclass => class extends superclass {

    pads = [];

    schedulePads() {
        this.pads.forEach(
            pad => pad.onNewStep());
    }

    sendPadMessages(time) {
        this.pads.forEach(
            pad => pad.sendPadMessages(time));
    }

    async loadPackAsPads(pads, fx, pad, packHash) {
        let newPad = pad || this.createPad();

        let newlyLoaded = [];
        newPad.packHash = packHash;
        for (let i=0; i < pads.length; i++) {
            let content = pads[i];
            if (!content) {
                continue;
            }
            newlyLoaded.push(i);
            console.log(content);
            let currentTrackType = pad && pad.slots[i] && pad.slots[i].getTrackType();
            let presetTrackType = content.preset.trackData.trackType;
            if (pad && pad.slots[i] && currentTrackType !== presetTrackType) {
                // delete track entirely and then load
                let trackNumber = pad.slots[i].trackNumber;
                pad.removeTrack(pad.slots[i]);
                this.sequencerEngine.deleteTrack(trackNumber);
                let track = await this.sequencerEngine.loadTrackPreset(
                    content.preset,
                    undefined,
                    true);
                newPad.addTrack(track, i);
            } if (pad && pad.slots[i]) {
                await this.sequencerEngine.auditionPreset(
                    {data: content.preset},
                    pad.slots[i].trackNumber,
                    undefined,
                    true,
                    false);
            } else {
                let track = await this.sequencerEngine.loadTrackPreset(
                    content.preset,
                    undefined,
                    true);
                newPad.addTrack(track, i);
            }
        }

        for (let i=0; i < pad.slots.length; i++) {
            if (pad.slots[i] && !newlyLoaded.includes(i)) {
                this.sequencerEngine.deleteTrack(pad.slots[i].trackNumber);
            }
        }

        if (fx) {
            newPad.effectRack.fromJson(fx, undefined, undefined, true);
            newPad.updateEffectRedux();
        }
    }

    deletePad(pad) {
        this.pads = this.pads.filter(p => p !== pad);
        pad.slotTracks.forEach(
            track => track.pad = undefined);
        this.updateRedux();
    }

    deleteTrackFromPads(track) {
        let pad = this.pads.find(
            x => x.slots.includes(track));
        if (!pad) {
            return;
        }
        pad.deleteTrack(track);
    }

    createPad(fromTracks, createRack, createZObject=true) {
        let pad = new Pad(this, createRack);

        let firstPad = this.pads.length === 0;
        if (createZObject) {
            let zobject = this.createZObject(5, 5, "pad");
            zobject.effect.linkPad(pad);

            if (this.state.samples.droppedSamples) {
                let len = this.state.samples.droppedSamples;
                console.log("droppped samples =", len);
                if (len > 9) {
                    zobject.setAttribute("Number of Pads", len);
                }
            }
        }
        this.pads = [... this.pads, pad];
        
        if (fromTracks) {
            let slot=0;
            for (let track of this.tracks) {
                if (!track.pad) {
                    pad.addTrack(track, slot++);
                }
                if (slot >= 9) {
                    slot = 0;
                    pad = new Pad(this);
                    this.pads = [... this.pads, pad];
                }
            }
        }
        this.updateRedux();
        if (firstPad && !this.sequencerEngine.isOffline) {
            this.dispatch(
                setShowPadSequencer(pad));
        }
        return pad;
    }

    checkPads() {
        let padObjects = this.findNodeByName("pad", true).map(
            x => x.effect.pad);

        for (let pad of this.pads) {
            if (!padObjects.includes(pad)) {
                // then we need to create a zobject and hook it up
                let position = this.state.windows.windowPositions[pad.id] || {x:0, y:0};
                let zobject = this.createZObject(position.x, position.y, "pad");
                zobject.effect.linkPad(pad);
            }
            pad.sendSliderLevels();
        }
    }

    updateRedux() {
        this.dispatch(
            setPads(
                this.id, this.pads));
    }

    getPadsJson() {
        return this.pads.map(p => p.getJson());
    }

    loadPadsJson(json) {
        if (!json) {
            return;
        }
        for (let _pad of json) {
            let pad = this.createPad(undefined, false, false);
            pad.fromJson(_pad);
        }
    }

    addTrackToPadIfPossible(track) {
        let foundPad = undefined;
        let foundIndex = undefined;
        if (this.state.spatial.showPadSequencer) {
            foundPad = this.state.spatial.showPadSequencer;
            if (foundPad === true) {
                foundPad = this.pads[0];
            }
            foundIndex = foundPad.tracks.indexOf(false);
            if (foundIndex === -1) {
                foundPad = undefined;
            }
        } else {
            for (let pad of this.pads) {
                let index = pad.tracks.indexOf(false);
                if (index > -1 &&
                    !pad.tracks.includes(track)) {
                    foundIndex = index;
                    foundPad = pad;
                }
            }
        }

        if (foundPad) {
            foundPad.addTrack(track, foundIndex, true);
            return;
        }

        // theres no pad so create one and add
        if (this.state.sequencer.viewMode === MIX_VIEW) {
            let pad = this.createPad();
            this.dispatch(setWindowPosition(pad.id, {x: 5, y: 5}));
            this.createZObject(0, 310, "cirklon");
            //this.createZObject(500, 100, "patterns");
            pad.addTrack(track, 0, true);
            this.sequencerEngine.selectTrack(track.trackNumber);

        }
    }

}

// setPadTracks (pad id -> tracks)
// setPads (sub id -> pads)
